import useTranslate from 'app/i18n/useTranslate';

const useTranslation = () => {
    const t = useTranslate('clientNameField');

    return {
        CLIENT_NAME_FIELD_LABEL: t('clientNameFieldLabel')
    };
};

export default useTranslation;
